import './day-zero.scss';
import React from 'react';
import Loader from '../../shared/loader/loader';
import DDLogo from '@svg/dd-logo-small.svg?react';
import { observer } from 'mobx-react-lite';

export const DayZero: React.FC = observer(() => {
    return <>
        <DDLogo className="logo-day-zero" />
        <div className="on-land">
            <div className="circle-background" />
            <div className="on-land-card">
                <div className="loader"><Loader type="component" /></div>
                <div className="on-land-card-text">We are almost done preparing your account.
                    Please wait for few moments...</div>
            </div>
        </div>
    </>;
});